import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import moment from 'moment';
import {getDateFormat} from '../../../Utils/UserFunctions';
import {checkViolationsExist,getViolationsMsg} from '../../../Utils/CommonFunctions';

const ForecastSettings = (props) => {
    const [monthRecord,setMonthRecord] = useState(['January','February','March','April','May','June','July','August','September','October','November','December']);
    const [screen,setScreen] = useState('new');
	const curState = props.curState;
    const forecastSettingsData = curState.forecastSettings;
    const windowFields = curState.windowFields;
    const forcastId = forecastSettingsData ? forecastSettingsData.id : null;
    const forecastFields = curState.forecastsSetting_formsfields;
    const violations = curState.violations;

    let fieldOptions = '';
    if(windowFields) {
        if(windowFields.numeric_fields) {
            if(windowFields.numeric_fields['Opportunity']) {
                fieldOptions = windowFields.numeric_fields['Opportunity'].map((arr,i) => {
                    return <option key={i} value={arr.id}>{arr.field_name}</option>
                })
            }
        }
    }
    const getMonthName = (id) => {
        let monthName = '';
        monthRecord.map((arr,i) => {
            if(id === (i+1)) {
                monthName = arr;
            }
        })
        return monthName;
    }

    const editHandler = () => {
        setScreen('edit');
    }

    const saveHandler = () => {
        setScreen('new');
        props.saveForcastSettings();
    }

    const toggleModel = () => {
        setScreen('new');
        props.toggleModel();
    }
	return (
		<Modal size="lg" show={props.modelOpen} onHide={toggleModel}>
            <Modal.Header>
                <h5 classNameName="modal-title secondary_color pl-2" style={{"marginBottom":"0px"}}> Forecast Settings </h5>
            </Modal.Header>
            <Modal.Body>
            {   
                forcastId && screen !== 'edit' ?
                    <div className="table-responsive "> 
                        <table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th> Forecast Hierarchy </th>
                                    <th> Target Period </th>
                                    <th> Start Month </th>
                                    <th> Display year based on </th>
                                    <th> Target based on </th>
                                </tr>
                            </thead>  
                            <tbody>
                                <tr>                                 
                                    <td> 
                                        {
                                            forecastSettingsData.hierarchy_type === 0 ? 'Role' : 'Territory'
                                        }
                                    </td>                             
                                    <td>
                                        {
                                            forecastSettingsData.target_period === 0 ? 'Monthly' : 'Quarterly'
                                        }
                                    </td>                           
                                    <td> {getMonthName(forecastSettingsData.begin_month)} </td>    
                                    <td>
                                        {
                                            forecastSettingsData.year_reference === 0 ? 'Start Month' : 'End Month'
                                        }
                                    </td>
                                    <td>
                                        {
                                            forecastSettingsData.display_name
                                        }
                                    </td>
                                </tr>
                            </tbody> 
                        </table>
                    </div>
                :
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label> Forecast Hierarchy </label>
                            <input type="" name="" className="form-control" disabled={true} value={forecastSettingsData ? forecastSettingsData.has_territory_enabled === true ? 'Territory' : 'Role' : 'Role'}/>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="form-group">
                            <label> Target Period </label>
                            <select className="form-control" name="target_period" value={forecastFields.target_period} onChange={props.forecastSettingsChangeHandler}>
                                <option value="">Select Period</option>
                                <option value="0">Monthly</option>
                                <option value="1">Quarterly</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className={checkViolationsExist('beginMonth',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> Fiscal Year Begins in </label>
                            <select className="form-control" name="begin_month" value={forecastFields.begin_month} onChange={props.forecastSettingsChangeHandler}>
                                {
                                    monthRecord.map((arr,i) => {
                                        return <option value={i+1}>{arr}</option>
                                    })
                                }
                            </select>
                            { checkViolationsExist('beginMonth',violations) === true ? 
                                <label className="error m-0">{getViolationsMsg('beginMonth',violations)}</label>
                                : null
                            }
                        </div>
                    </div>
                    {
                        parseInt(forecastFields.begin_month) !== 1 ?
                            <div className="col-6">
                                <div className="form-group">
                                    <label> Display Fiscal Year Based on </label><br/>
                                    <label className="selectgroup-item">
                                        <input type="radio" name="year_reference" value={0} className="selectgroup-input" checked={(parseInt(forecastFields.year_reference) === 0) ? true : false} onChange={props.forecastSettingsChangeHandler}/>
                                        <span className="selectgroup-button">Start Month</span>
                                    </label>
                                    <label className="selectgroup-item">
                                       <input type="radio" name="year_reference" value={1} className="selectgroup-input" checked={(parseInt(forecastFields.year_reference) === 1) ? true : false} onChange={props.forecastSettingsChangeHandler}/>
                                        <span className="selectgroup-button">End Month</span>
                                    </label>
                                </div>
                            </div>
                        : null
                    }
                    

                    <div className="col-6">
                        <div className={checkViolationsExist('targetTableDescriptorId',violations) === true ? "form-group has-error" : "form-group"}>
                            <label> Target based on </label>
                            <select className="form-control" name="target_tabledescriptor_id" value={forecastFields.target_tabledescriptor_id} onChange={props.forecastSettingsChangeHandler}>
                                <option>Select Field</option>
                                {fieldOptions}
                            </select>
                            { checkViolationsExist('targetTableDescriptorId',violations) === true ? 
                                <label className="error m-0">{getViolationsMsg('targetTableDescriptorId',violations)}</label>
                                : null
                            }
                        </div>
                    </div>
                </div>
            }
                
            </Modal.Body>

            <Modal.Footer>
               
                    <a onClick={toggleModel} className="btn btn-cancel mr-2" data-dismiss="modal"> Cancel </a> 
                {   
                forcastId && screen !== 'edit' ?
                <a onClick={editHandler} className="btn primary_bg"> Edit </a>
                :
                <a onClick={saveHandler} className="btn primary_bg"> Save </a>
                }
                    
                 
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(ForecastSettings);